$(document).ready( function(){
  checkItemsInDropdownCart();
});

Shopify.onItemAdded = function(line_item) {
 Shopify.getCart();
}; 

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.minicart .has__items ul.clearfix');
};

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {
      cart_cell.empty();
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          if (value.length) {
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }                   
              $('<li class="minicart--item"><div class="placeholder"><a href="' + item.url + '"><img src="' + item.image + '" alt=""/></a></div><h1 class="title">' + item.title + '</h1></p><p class="price">' + Shopify.formatMoney(item.price) + ' (' + item.quantity + ')</p><p class="remove" data-id="' + item.id + '"><a href="#"><i class="fa fa-trash" aria-hidden="true"></i><span class="w-20"></span>Remove</a></p></li>').appendTo(table);
            });
          }
          else {
            jQuery(".header-cart .dropdown-toggle").css({"cursor": "default"});
          }
        }
      });
      checkItemsInDropdownCart();
      $('.minicart').css('display','block');
    }
  }
  var cart_count = cart.item_count;
  var cart_amount = Shopify.formatMoney(cart.total_price);
  $('.item_count').html(cart_count);
  $('.cart_amount').html(cart_amount);
      if(cart_count > 1) {
  	$(".items_").html("Items");
  }
}


function checkItemsInDropdownCart() {
  if($('.has__items ul').children('li').length > 0) {
      $(".minicart .no__items").hide();
      $(".minicart .has__items").show();
  } 
    else {
      $(".minicart .no__items").show();
      $(".minicart .has__items").hide();
  }
}


    $('form[action="/cart/add"]').submit(function(e) {
        e.preventDefault();
        var $addToCartForm = $(this);
        $.ajax({
          type: "post",
          url: "/cart/add.js",
          dataType: 'json',
          data: $addToCartForm.serialize(),
          success: function(line_item) {
              if ((typeof callback) === 'function') {
                  callback(line_item);
              }
              else {
                  Shopify.onItemAdded(line_item);
              }
          },
         error: function(xhr, text) {
         $("#error-modal").css('display','block');
         }
      });
     });
  

  $(document).on('click', 'p.remove', function() {
      var value2 = $(this).data("id");
        $.ajax({
          type: "post",
          url:'/cart/change.js',
          dataType: 'json',
          data:  'quantity='+0+'&id='+value2,
          success: function(line_item) {
              if ((typeof callback) === 'function') {
                  callback(line_item);
              }
              else {
                  Shopify.onItemAdded(line_item);
              }
          },
         error: function(xhr, text) {
         }
      });
     });


//     $(document).on('change', 'input.quantity', function() {
//     var value1 = $(this).val();
//     var value2 = $(this).next('#variant-id').val().split(":");
//         $.ajax({
//           type: "post",
//           url:'/cart/change.js',
//           dataType: 'json',
//           data:  'quantity='+value1+'&id='+value2[0],
//           success: function(line_item) {
//               if ((typeof callback) === 'function') {
//                   callback(line_item);
//               }
//               else {
//                   Shopify.onItemAdded(line_item);
//               }
//           },
//          error: function(xhr, text) {
//          }
//       });
//   });
   